export enum LicenseTypeEnum {
  Unify,
  Accelerate,
  Scale,
  Enterprise,
  BigCommerce,
}
